import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { Buffer } from 'buffer';
import { redirectEmbeddedBrowser } from './app/shared/utils/external-browser.utils';

import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

(globalThis as any).Buffer = Buffer;

function isInstagramNavigationLoggerError(event: any): boolean {
  const exception = event?.exception?.values?.[0];
  const message = exception?.value || '';
  const frames = exception?.stacktrace?.frames || [];
  const stack = frames.map((frame: any) => `${frame?.filename || ''} ${frame?.function || ''}`).join(' ');

  return message.includes('Error invoking postMessage') && stack.includes('navigation_performance_logger');
}

const redirectingToBrowser = redirectEmbeddedBrowser(window);

if (!redirectingToBrowser && environment.production && location.hostname !== 'localhost') {
  Sentry.init({
    dsn: 'https://85904f6f372f6244c7a146439f134a88@o4509394750799872.ingest.us.sentry.io/4510047621545984',
    sendDefaultPii: true,
    beforeSend(event) {
      const msg = event?.exception?.values?.[0]?.value || '';
      const ignored = [
        'Java object is gone',
        'webkit.messageHandlers',
        'navigation_performance_logger',
        'Importing a module script failed',
        'Failed to fetch dynamically imported module',
        'Failed to load module script',
        'ChunkLoadError'
      ];
      return ignored.some((s) => msg.includes(s)) || isInstagramNavigationLoggerError(event) ? null : event;
    }
  });
}

if (!redirectingToBrowser) {
  bootstrapApplication(AppComponent, appConfig)
    .then(() => {
      // Avisa o vigia de boot do src/index.html (plano 3, Fase 4b). Se ele já tinha desistido (aparelho lento),
      // tira a classe e o bloco de contato volta a ficar escondido.
      (window as unknown as { __agjBooted?: boolean }).__agjBooted = true;
      document.documentElement.classList.remove('agj-boot-failed');
    })
    .catch((err) => console.error(err));
}
